import React, { useState } from "react";
import { Form, Input, Select, Button, Row, Col, message,notification,TimePicker,InputNumber } from "antd";
import { post } from "../../../../api/post";
import { getAccessTokenApi } from "../../../../api/auth";

import "./AddHubsForm.scss";

export default function AddHubsForm(props) {
  const { setIsVisibleModal, setReloadHubs } = props;
  const [hubData, setHubData] = useState({});
  //const { hubData, setHubData } = props;
  const { Option } = Select;
  //console.log('entro a add form')
  //console.log(hubData);
  const addHub = (event) => {
    //console.log('entro a add user form interno')
    event.preventDefault();

    if (
      !hubData.name ||
      !hubData.postalCode ||
      !hubData.latitud ||
      !hubData.longitud ||
      !hubData.earlyTime ||
      !hubData.lateTime||
      !hubData.monthlypayment
    ) {
      // notification["error"]({
      //   message: "Todos los campos son obligatorios.",
      // });
      message.error("Todos los campos son obligatorios.")
    }else {
      //const accesToken = getAccessTokenApi();

      // createHubAPI(hubData)
      post(hubData,'create-hub','create-hub','')
        .then((response) => {
          // notification["success"]({
          //   message: response,
          // });
          message.success('Hub created')
          setIsVisibleModal(false);
          // setHubData({});
          setReloadHubs(true);
        })
        .catch((err) => {
          // notification["error"]({
          //   message: err.message,
          // });
          message.error(err.message)
        });
    }
    //console.log("CREARUSUARIO");
    //console.log(hubData); 
  };
  return (
    <Form className="form-add" onSubmit={addHub}>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Name"
              value={hubData.name}
              onChange={(e) =>
                setHubData({ ...hubData, name: e.target.value })
              }
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Postal code'
              name='Postal code'
              min={0}
              max={9999999}
              step={1}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={0} 
              defaultValue={hubData.postalCode}
              onChange={(e) => 
                {setHubData({ ...hubData, postalCode: e })}}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Latitude'
              name='latitude'
              min={-180}
              max={180}
              step={0.0000001}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.latitud}
              onChange={(e) => 
                {setHubData({ ...hubData, latitud: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Longitude'
              name='longitude'
              min={-180}
              max={180}
              step={0.0000001}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.latitud}
              onChange={(e) => 
                {setHubData({ ...hubData, longitud: e })}}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <TimePicker 
            name='Early Time'
            placeholder="Early Time"
            // value={hubData.earlyTime}
            format={'HH:mm'} 
            onChange={(time)=>{
              setHubData({ ...hubData, earlyTime: time.format('HH:mm') })
              }}/>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
              <TimePicker 
              name='Late Time'
              placeholder="Late Time"
              // value={hubData.lateTime}
              format={'HH:mm'} 
              onChange={(time)=>{
                setHubData({ ...hubData, lateTime: time.format('HH:mm') })
                }}/>
            </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Monthly payment'
              name='monthly payment'
              min={0}
              max={9999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              defaultValue={0} 
              // value={hubData.postalCode}
              onChange={(e) => 
                {setHubData({ ...hubData, monthlypayment: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <Button style={{
          backgroundColor:'white',
          width:'225px',
          borderWidth:'2px',
          fontSize:'15px',
          color:'rgb(35,148,212)',
          fontFamily:'report-bold',
        }} type="submit" htmlType="submit" className="btn-submit" onClick={addHub}>
              Create Hub
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
